import { useSelector, useDispatch } from "react-redux";
import { DefaultRootState } from "@reduxLocal/persistState";
import Tabs from "./Components/Tabs";
import { View } from "react-native";
import * as Animatable from 'react-native-animatable';
import React, {useEffect} from "react";
import { ADD_TAB } from "@reduxLocal/actions/types";
import { useNavigation } from "@react-navigation/native";
import { uniqueId } from "lodash";

const TabNavigator = () => {
  const currentTab = useSelector((state: DefaultRootState) => state.navigation.tabs.length);
  const openTabs = useSelector((state: DefaultRootState) => state.navigation.tabs)
  const activeTab = openTabs.filter((tabs) => tabs.active);
  const dispatch = useDispatch();
  const navigation = useNavigation();
    const idGen = uniqueId();
  

useEffect(()=>{
  if(!openTabs.length){
    //Set default tab to current page
    dispatch({ type: ADD_TAB, payload: { active: true, id: idGen, page: 'Welcome' } }), navigation.navigate('Welcome')
  }
},[])

  const fadeIn = {
    from: {
      flex: 0.0001,
    },
    to: {
      flex: 0.14,
    },
  };



  return (
    <View style={{ alignSelf: "stretch", gap: 5, flexDirection: 'row' }} >
      {currentTab > 0 ?
        openTabs.map((tabs: { id: any; page: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined; }, k: React.Key | null | undefined) => {
          return (
            <Animatable.View useNativeDriver style={{ alignSelf: "stretch", minWidth: 200, borderRadius: 5 }} key={k} animation={fadeIn} duration={300}>
              <Tabs  {...{ tabs, activeTab, currentTab }} key={k} />
            </Animatable.View>
          )
        }
        )
        : null
      }
    </View>
  )
}

export default TabNavigator;
